/* GOSS persistent vehicle — Rivian-gearshop-style "remember my truck".
   Stores the customer's selected truck in localStorage, shows a header chip,
   and renders a fit badge on product pages by matching product tags. */
(function () {
  var KEY = 'goss:vehicle';
  var EVT = 'goss:vehicle:changed';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return null;
      var v = JSON.parse(raw);
      return v && v.make && v.model ? v : null;
    } catch (e) {
      return null;
    }
  }

  function write(vehicle) {
    try {
      if (vehicle) localStorage.setItem(KEY, JSON.stringify(vehicle));
      else localStorage.removeItem(KEY);
    } catch (e) { /* private mode */ }
    document.dispatchEvent(new CustomEvent(EVT, { detail: read() }));
  }

  window.GossVehicle = {
    get: read,
    set: function (v) { write(v); },
    clear: function () { write(null); },
    label: function () {
      var v = read();
      if (!v) return '';
      return (v.year ? v.year + ' ' : '') + v.make + ' ' + v.model;
    }
  };

  /* ---------- Fitment map (keep in sync with homepage hero blocks) ---------- */
  var FITMENT = [
    { make: 'Kenworth', model: 'T680 Next Gen', yearFrom: 2022, yearTo: 0, url: '/collections/serie-4000-kenworth®-t680-next-gen' },
    { make: 'Kenworth', model: 'T680 Legacy', yearFrom: 2012, yearTo: 2021, url: '/collections/serie-4000-kenworth®-t680-legacy' },
    { make: 'Kenworth', model: 'T880', yearFrom: 2014, yearTo: 0, url: '/collections/serie-4000-kenworth®-t880' },
    { make: 'Kenworth', model: 'T480', yearFrom: 2021, yearTo: 0, url: '/collections/serie-4000-kenworth®-t480' },
    { make: 'Freightliner', model: 'Cascadia P3', yearFrom: 2008, yearTo: 2017, url: '/collections/freightliner-cascadia-p3' },
    { make: 'Freightliner', model: 'Cascadia P4', yearFrom: 2018, yearTo: 2025, url: '/collections/freightliner-cascadia-p4-y-g5' },
    { make: 'Freightliner', model: 'Cascadia 5th Gen', yearFrom: 2025, yearTo: 0, url: '/collections/freightliner-cascadia-p4-y-g5' },
    { make: 'International', model: 'LT', yearFrom: 2017, yearTo: 0, url: '/collections/international-lt' },
    { make: 'DAF', model: 'XF', yearFrom: 2013, yearTo: 0, url: '/collections/daf-xf' },
    { make: 'Peterbilt', model: '579', yearFrom: 2013, yearTo: 0, url: '/collections/peterbilt-579' }
  ];
  var NOW_YEAR = new Date().getFullYear();
  FITMENT.forEach(function (v) { if (!v.yearTo) v.yearTo = NOW_YEAR; });

  /* ---------- Fit-your-vehicle modal (Rivian style) ---------- */
  var modalEl = null;

  function buildModal() {
    if (modalEl) return modalEl;
    modalEl = document.createElement('div');
    modalEl.className = 'goss-fitmodal';
    modalEl.hidden = true;
    modalEl.innerHTML =
      '<div class="goss-fitmodal__overlay" data-fitmodal-close></div>' +
      '<div class="goss-fitmodal__dialog" role="dialog" aria-modal="true" aria-label="Selecciona tu vehículo">' +
      '<button type="button" class="goss-fitmodal__close" data-fitmodal-close aria-label="Cerrar">&times;</button>' +
      '<h2 class="goss-fitmodal__title">Selecciona tu vehículo</h2>' +
      '<p class="goss-fitmodal__sub">Te mostraremos las piezas fabricadas para que encajen exactamente en tu vehículo.</p>' +
      '<form class="goss-fitmodal__form">' +
      '<label>Año<select data-fm-year required><option value="">Selecciona el año</option></select></label>' +
      '<label>Marca<select data-fm-make required disabled><option value="">Selecciona la marca</option></select></label>' +
      '<label>Modelo<select data-fm-model required disabled><option value="">Selecciona el modelo</option></select></label>' +
      '<button type="submit" class="goss-fitmodal__submit" disabled>Buscar mis piezas</button>' +
      '</form></div>';
    document.body.appendChild(modalEl);

    var yearEl = modalEl.querySelector('[data-fm-year]');
    var makeEl = modalEl.querySelector('[data-fm-make]');
    var modelEl = modalEl.querySelector('[data-fm-model]');
    var submitEl = modalEl.querySelector('.goss-fitmodal__submit');
    var form = modalEl.querySelector('form');

    function setOptions(sel, vals, ph) {
      sel.innerHTML = '';
      var o = document.createElement('option');
      o.value = ''; o.textContent = ph; sel.appendChild(o);
      vals.forEach(function (v) {
        var x = document.createElement('option');
        x.value = v; x.textContent = v; sel.appendChild(x);
      });
    }
    function matches(v, y, m) {
      if (y && (y < v.yearFrom || y > v.yearTo)) return false;
      if (m && v.make !== m) return false;
      return true;
    }
    function uniq(a) { return a.filter(function (x, i) { return a.indexOf(x) === i; }); }

    var minY = Math.min.apply(null, FITMENT.map(function (v) { return v.yearFrom; }));
    var maxY = Math.max.apply(null, FITMENT.map(function (v) { return v.yearTo; }));
    var years = []; for (var y = maxY; y >= minY; y--) years.push(y);
    setOptions(yearEl, years, 'Selecciona el año');

    yearEl.addEventListener('change', function () {
      var y = parseInt(yearEl.value, 10) || null;
      makeEl.disabled = !y; modelEl.disabled = true; submitEl.disabled = true;
      setOptions(modelEl, [], 'Selecciona el modelo');
      if (!y) { setOptions(makeEl, [], 'Selecciona la marca'); return; }
      setOptions(makeEl, uniq(FITMENT.filter(function (v) { return matches(v, y, null); }).map(function (v) { return v.make; })).sort(), 'Selecciona la marca');
    });
    makeEl.addEventListener('change', function () {
      var y = parseInt(yearEl.value, 10) || null;
      var m = makeEl.value || null;
      modelEl.disabled = !m; submitEl.disabled = true;
      if (!m) { setOptions(modelEl, [], 'Selecciona el modelo'); return; }
      setOptions(modelEl, uniq(FITMENT.filter(function (v) { return matches(v, y, m); }).map(function (v) { return v.model; })).sort(), 'Selecciona el modelo');
    });
    modelEl.addEventListener('change', function () { submitEl.disabled = !modelEl.value; });

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var y = parseInt(yearEl.value, 10) || null;
      var match = FITMENT.find(function (v) {
        return v.make === makeEl.value && v.model === modelEl.value && matches(v, y, makeEl.value);
      });
      if (!match) return;
      write({ year: y, make: match.make, model: match.model, url: match.url });
      closeModal();
      window.location.href = match.url;
    });

    // Delegated: any click on a close control (or a near-miss inside its padding) closes
    modalEl.addEventListener('click', function (e) {
      if (e.target.closest('[data-fitmodal-close]')) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });

    modalEl._prefill = function () {
      var v = read();
      if (!v || !v.year) return;
      yearEl.value = String(v.year);
      yearEl.dispatchEvent(new Event('change'));
      if (v.make) {
        makeEl.value = v.make;
        makeEl.dispatchEvent(new Event('change'));
        if (v.model) {
          modelEl.value = v.model;
          modelEl.dispatchEvent(new Event('change'));
        }
      }
    };
    return modalEl;
  }

  function openModal() {
    buildModal();
    modalEl._prefill();
    modalEl.hidden = false;
    document.documentElement.classList.add('goss-fitmodal-open');
    var first = modalEl.querySelector('[data-fm-year]');
    if (first) first.focus();
  }
  function closeModal() {
    if (!modalEl) return;
    modalEl.hidden = true;
    document.documentElement.classList.remove('goss-fitmodal-open');
  }
  window.GossVehicle.openModal = openModal;

  /* ---------- Header chip ---------- */
  function renderChip() {
    var mount = document.querySelector('[data-goss-vehicle-chip]');
    if (!mount) return;
    var v = read();
    var CAR_ICON = '<svg class="goss-chip__icon" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M1 15h3m0 0a3 3 0 1 0 6 0m-6 0V6a1 1 0 0 1 1-1h9v10m0 0h2m-2 0a3 3 0 1 0 6 0m0 0h2v-5l-3-4h-5"/></svg>';
    mount.hidden = false;
    if (!v) {
      mount.innerHTML =
        '<button type="button" class="goss-chip goss-chip--cta" aria-haspopup="dialog">' + CAR_ICON +
        '<span class="goss-chip__label">Elige tu vehículo</span></button>';
      mount.querySelector('.goss-chip').addEventListener('click', openModal);
      return;
    }
    mount.innerHTML =
      '<button type="button" class="goss-chip" aria-haspopup="dialog" aria-label="Cambiar tu camión (actualmente ' +
      (v.make + ' ' + v.model).replace(/"/g, '&quot;') + ')">' + CAR_ICON +
      '<span class="goss-chip__label">' + window.GossVehicle.label() + '</span>' +
      '</button>' +
      '<button type="button" class="goss-chip__clear" aria-label="Borrar mi camión">&times;</button>';
    mount.querySelector('.goss-chip').addEventListener('click', openModal);
    mount.querySelector('.goss-chip__clear').addEventListener('click', function () {
      window.GossVehicle.clear();
    });
  }

  /* ---------- Product page fit badge ---------- */
  function renderFitBadge() {
    var el = document.querySelector('[data-goss-fit]');
    if (!el) return;
    var v = read();
    var tags = (el.getAttribute('data-product-tags') || '').toLowerCase();
    if (!v) {
      el.innerHTML =
        '<span class="goss-fit goss-fit--neutral">¿No estás seguro de la compatibilidad? ' +
        '<a href="/#VehicleSelectorForm">Selecciona tu camión</a></span>';
      return;
    }
    var modelMatch = tags.indexOf(v.model.toLowerCase()) !== -1;
    var makeMatch = tags.indexOf(v.make.toLowerCase()) !== -1;
    if (modelMatch) {
      el.innerHTML =
        '<span class="goss-fit goss-fit--yes">&#10003; Compatible con tu ' + window.GossVehicle.label() + '</span>';
    } else if (makeMatch) {
      el.innerHTML =
        '<span class="goss-fit goss-fit--warn">&#9888; Fabricado para otro modelo de ' + v.make +
        ' &mdash; tú manejas un ' + v.model + '</span>';
    } else {
      el.innerHTML =
        '<span class="goss-fit goss-fit--warn">&#9888; No disponible para tu ' + window.GossVehicle.label() +
        ' &mdash; <a href="' + encodeURI(v.url || '/') + '">ver piezas compatibles</a></span>';
    }
  }

  /* ---------- Collection page vehicle banner ---------- */
  function renderCollectionBanner() {
    var el = document.querySelector('[data-goss-collection-banner]');
    if (!el) return;
    var v = read();
    if (!v) { el.hidden = true; el.innerHTML = ''; return; }
    var here = decodeURIComponent(location.pathname);
    var mine = decodeURIComponent((v.url || '').split('?')[0]);
    el.hidden = false;
    if (mine && here === mine) {
      el.innerHTML =
        '<div class="goss-cbanner"><span class="goss-cbanner__text">' +
        'Mostrando piezas para tu <strong>' + window.GossVehicle.label() + '</strong></span>' +
        '<button type="button" class="goss-cbanner__clear">Borrar vehículo <span aria-hidden="true">&times;</span></button></div>';
      el.querySelector('.goss-cbanner__clear').addEventListener('click', function () {
        window.GossVehicle.clear();
      });
    } else {
      el.innerHTML =
        '<div class="goss-cbanner"><span class="goss-cbanner__text">' +
        'Tu camión es <strong>' + window.GossVehicle.label() + '</strong></span>' +
        '<a class="goss-cbanner__link" href="' + encodeURI(v.url || '/') + '">Ver piezas compatibles &rarr;</a></div>';
    }
  }

  function renderAll() {
    renderChip();
    renderFitBadge();
    renderCollectionBanner();
  }

  document.addEventListener(EVT, renderAll);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderAll);
  } else {
    renderAll();
  }
})();
